import {
  IonIcon,
  IonItem,
  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { roseOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./DBSCANIris.css";

function DBSCANIris() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <IonItem className="ion-hide-sm-up">
        <IonIcon icon={roseOutline} slot="start" className="ion-icon" />
        <IonModal
          isOpen={showModal}
          className="ion-modal-popup"
          backdropDismiss="false"
        >
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b> DBSCAN with Iris </b>
            <p>
              {" "}
              Another project I worked on for CharacTour was implementing
              DBSCAN(density - based clustering of applications with noise) to
              derive user insights.While the data is also confidential, I
              replicated it with the Iris dataset in <code> R </code> Through
              this unsupervised machine learning tactic, I was able to procure
              useful results to better understand complex user behavior.{" "}
            </p>
            <a
              href="https://cameronlowdata.shinyapps.io/DSApplication/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Click here to see the dashboard.{" "}
            </a>{" "}
            <br />
            <IonButton
              className="ion-button"
              onClick={() => setShowModal(false)}
            >
              {" "}
              Close{" "}
            </IonButton>{" "}
            <br />
          </IonText>
        </IonModal>
        <IonButton className="ion-button" onClick={() => setShowModal(true)}>
          {" "}
          Show{" "}
        </IonButton>{" "}
      </IonItem>
    </div>
  );
}

export default DBSCANIris;
